import { cloneDeep } from 'lodash';

import getError4xx from '@/api/interceptors/getError4xx';
import getError5xx from '@/api/interceptors/getError5xx';
import { useAlertStore } from '@/stores/alert';
import { IAppError } from '@/types/response';

export function getResponseError(error): IAppError {
  const { code: httpCode = '', config: { url = '' } = { url: '' }, response = {} } = error;

  const {
    data: { code: errorCode = 0, message: errorMessage = '' } = {
      code: 0,
      message: '',
    },
    status = 400,
  } = response;

  const resError: IAppError = {
    data: null,
    httpCode,
    status,
    errorCode,
    errorMessage,
    success: false,
  };

  const isTransientDns = () => {
    // Axios sets err.response only when the server replied. DNS/NETWORK errors have no response.
    const msg = String(error?.message || '').toUpperCase();
    const code = String(error?.code || '').toUpperCase();
    return (
      !error?.response &&
      (code === 'ERR_NAME_NOT_RESOLVED' || msg.includes('ERR_NAME_NOT_RESOLVED') || code === 'ERR_NETWORK') // mobile resume flips often show this
    );
  };

  if (isTransientDns()) return { ...resError, retry: true };

  if (!status) {
    const store = useAlertStore();
    console.error('NETWORK ERROR:', error);
    store.alertNetworkError(error);
  } else if (['/api/partner/auth', '/api/partner/auth/logout'].includes(url)) {
    Object.assign(resError, {});
  } else if (String(status).startsWith('4')) {
    Object.assign(resError, cloneDeep(getError4xx(resError)));
  } else if (String(status).startsWith('5')) {
    Object.assign(resError, cloneDeep(getError5xx(resError)));
  }

  return resError;
}
